import { PcbNodeTypes } from "@buildwithflux/models";
import { getMechanicalExpressionDependencies } from "../../expression_engine";
import { circleNodeRuleKeys, containerNodeRuleKeys, elementNodeRuleKeys, footprintNodeRuleKeys, groupNodeRuleKeys, layoutNodeRuleKeys, lineNodeRuleKeys, modelNodeRuleKeys, netNodeRuleKeys, padNodeRuleKeys, rectangleNodeRuleKeys, routeNodeRuleKeys, textNodeRuleKeys, viaNodeRuleKeys, zoneNodeRuleKeys, } from "../node_baking";
/**
 * NOTE: getRequiredDependenciesToBakeNode is not called anywhere outside of
 * tests currently.
 */
export function getRequiredDependenciesToBakeNode(nodeData, flattenedRules) {
    switch (nodeData.type) {
        case PcbNodeTypes.pad: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, padNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.footprint: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, footprintNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.layout: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, layoutNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.model: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, modelNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: ["elements", "assets"],
            };
        }
        case PcbNodeTypes.element: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, elementNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.container: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, containerNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.group: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, groupNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.text: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, textNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.line: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, lineNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.circle: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, circleNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.rectangle: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, rectangleNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.via: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, viaNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.net: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, netNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.routeSegment: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, routeNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
        case PcbNodeTypes.zone: {
            const expressionContextDeps = getExpressionDependencies(flattenedRules, zoneNodeRuleKeys);
            return {
                expressionContext: expressionContextDeps,
                documentData: [],
            };
        }
    }
    return undefined;
}
function getExpressionDependencies(flattenedRules, nodeRuleKeys) {
    const expressionDeps = [];
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    Object.values(flattenedRules).forEach((rule) => {
        if (nodeRuleKeys.includes(rule.key) && typeof rule?.value === "string") {
            const deps = getMechanicalExpressionDependencies(rule?.value);
            if (deps) {
                expressionDeps.push(...deps);
            }
        }
    });
    return [...new Set(expressionDeps)];
}
//# sourceMappingURL=getRequiredDependenciesToBakeNode.js.map